import {
  HBO_COMMUNICATION_INTENT_SETTLE_MS,
  HBO_COMMUNICATION_INTENT_TTL_MS,
  HBO_COMMUNICATION_ORIGIN,
} from '../constants';

const INTENT_KEY = 'hbo_communication_intent';
const INTENT_VERSION = 1;

// La intencion es un indicador fijo: nunca se guarda ni se lee una URL de destino (CF-19)
export const saveHboCommunicationIntent = (now = Date.now()) => {
  try {
    sessionStorage.setItem(
      INTENT_KEY,
      JSON.stringify({
        v: INTENT_VERSION,
        origin: HBO_COMMUNICATION_ORIGIN.DIRECT_LINK,
        createdAt: now,
      }),
    );
  } catch (error) {
    // sessionStorage no disponible: se pierde la reanudacion, el usuario queda en Home
  }
};

export const clearHboCommunicationIntent = () => {
  try {
    sessionStorage.removeItem(INTENT_KEY);
  } catch (error) {
    // sin acceso al storage
  }
};

const isValidIntent = (intent, now) =>
  Boolean(intent) &&
  typeof intent === 'object' &&
  intent.v === INTENT_VERSION &&
  intent.origin === HBO_COMMUNICATION_ORIGIN.DIRECT_LINK &&
  typeof intent.createdAt === 'number' &&
  (intent.resumedAt === undefined || typeof intent.resumedAt === 'number') &&
  now - intent.createdAt <= HBO_COMMUNICATION_INTENT_TTL_MS;

// Vigente = valida, dentro del TTL y, si ya se reanudo, dentro de la ventana de asentamiento
const isActiveIntent = (intent, now) =>
  isValidIntent(intent, now) &&
  now - (intent.resumedAt ?? now) <= HBO_COMMUNICATION_INTENT_SETTLE_MS;

// Devuelve true si hay que (re)llevar al usuario a la pantalla. NO consume la intencion:
// la conserva durante la ventana de asentamiento (desde la primera reanudacion) para reafirmar
// si un flujo de login/perfil lo manda a Home despues. Fuera de la ventana, o invalida, la borra.
export const claimHboCommunicationIntent = (now = Date.now()) => {
  try {
    const raw = sessionStorage.getItem(INTENT_KEY);

    if (raw === null) return false;

    const intent = JSON.parse(raw);

    if (!isActiveIntent(intent, now)) {
      clearHboCommunicationIntent();

      return false;
    }

    if (intent.resumedAt === undefined) {
      sessionStorage.setItem(
        INTENT_KEY,
        JSON.stringify({
          v: INTENT_VERSION,
          origin: intent.origin,
          createdAt: intent.createdAt,
          resumedAt: now,
        }),
      );
    }

    return true;
  } catch (error) {
    clearHboCommunicationIntent();

    return false;
  }
};